import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const Phone = ({ style }: IconProps) => {
  const { theme } = useTheme();

  return (
    <svg
      width="34"
      height="35"
      viewBox="0 0 34 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M24.95 26.5C22.8667 26.5 20.8083 26.0458 18.775 25.1375C16.7417 24.2292 14.8917 22.9417 13.225 21.275C11.5583 19.6083 10.2708 17.7583 9.3625 15.725C8.45417 13.6917 8 11.6333 8 9.55C8 9.25 8.1 9 8.3 8.8C8.5 8.6 8.75 8.5 9.05 8.5H13.1C13.3333 8.5 13.5417 8.57917 13.725 8.7375C13.9083 8.89583 14.0167 9.08333 14.05 9.3L14.7 12.8C14.7333 13.0667 14.725 13.2917 14.675 13.475C14.625 13.6583 14.5333 13.8167 14.4 13.95L11.975 16.4C12.3083 17.0167 12.7042 17.6125 13.1625 18.1875C13.6208 18.7625 14.125 19.3167 14.675 19.85C15.1917 20.3667 15.7333 20.8458 16.3 21.2875C16.8667 21.7292 17.4667 22.1333 18.1 22.5L20.45 20.15C20.6 20 20.7958 19.8875 21.0375 19.8125C21.2792 19.7375 21.5167 19.7167 21.75 19.75L25.2 20.45C25.4333 20.5167 25.625 20.6375 25.775 20.8125C25.925 20.9875 26 21.1833 26 21.4V25.45C26 25.75 25.9 26 25.7 26.2C25.5 26.4 25.25 26.5 24.95 26.5Z"
        fill={theme.button.text.primary}
      />
    </svg>
  );
};
